import React from 'react';
import { apiBase } from '../../utils/config';
import moment from 'moment';
import UserImage from '../../assets/images/Logo.svg';
import PlaceHolderImage from '../../assets/images/UserImage.png';
import ActualWatermark from '../../assets/images/ActualWatermark.png';

const PreviewIDCardNew = React.forwardRef((props, ref) => {
    const { templateConfiguration, pdfData } = props;
    const fontStyle = templateConfiguration?.FontTheme || 'Arial';

    const getIconForKey = (key) => {
        switch (key) {
            case 'DOB': return 'pi pi-calendar';
            case 'BloodGroupIcon': return 'pi pi-tint';
            case 'Address': return 'pi pi-map-marker';
            case 'schoolContactNo': return 'pi pi-phone';
            case 'schoolEmail': return 'pi pi-envelope';
            default: return 'pi pi-info-circle';
        }
    }

    const x = pdfData;

    return (
        <div style={{ flex: '0 1 calc(19.90% - 6px)', marginLeft: '0px', marginTop: '0px', width: '207px', height: '334px', position: 'relative', justifyContent: 'center', backgroundColor: '#FFFFFF', border: '1px solid #ccc', overflow: 'hidden' }} ref={ref}>
            {/* Header Wave Background */}
            <svg viewBox="0 0 207 60" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '58px', zIndex: 2 }} preserveAspectRatio="none">
                <path d="M 0,0 L 207,0 L 207,36.5 C 195,26 175,22.9 147,22.9 C 100,23 55,52.3 0,52.3 Z" fill="#09419E" />
                <path d="M 74,51.5 C 105,47 130,42 147,42 C 170,42 195,51 207,57.5 L 207,47 C 195,40 170,35 147,35 C 125,35 95,44 74,51.5 Z" fill="#09419E" />
            </svg>

            {/* Header Content */}
            <div style={{ width: '100%', position: 'absolute', top: '7px', left: '8px', display: 'flex', alignItems: 'center', zIndex: 3 }}>
                <img
                    src={templateConfiguration?.SchoolImage ? `${apiBase}/TemplateSign/${templateConfiguration?.SchoolImage}` : x?.SchoolPhotoUrl ? `${apiBase}/UserProfilePic/${x?.SchoolPhotoUrl}` : UserImage}
                    style={{ width: '22px', height: '22px', objectFit: 'contain' }}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = UserImage;
                    }}
                />
                <div style={{ color: '#FFF', marginLeft: '5px', display: 'flex', flexDirection: 'column', maxWidth: '140px' }}>
                    <span style={{ fontSize: '8.5px', fontWeight: 'bold', fontFamily: fontStyle, lineHeight: 1.1 }}>{x?.SchoolName || ''}</span>
                </div>
            </div>

            {/* Background Watermark Image */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                backgroundImage: `url(${ActualWatermark})`,
                backgroundSize: '150px auto',
                backgroundPosition: 'top left',
                backgroundRepeat: 'repeat',
                opacity: 1,
                zIndex: 0
            }}></div>

            {/* Center Image */}
            <div style={{ position: 'absolute', top: '80px', left: '50%', transform: 'translateX(-50%)', width: '120px', height: '120px', borderRadius: '50%', backgroundColor: '#E0F2FE', zIndex: 4, overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img
                    src={x?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${x?.ProfilePhotoUrl}` : templateConfiguration?.IsHouseWiseImage ? `${apiBase}/TemplateBackGround/${x?.HouseBgImage}` : templateConfiguration?.BackGroundImage ? `${apiBase}/TemplateBackGround/${templateConfiguration?.BackGroundImage}` : PlaceHolderImage}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = PlaceHolderImage;
                    }}
                />
            </div>

            {/* Left Icons and Dynamic Data */}
            <div style={{ position: 'absolute', top: '205px', left: '10px', zIndex: 5, display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {templateConfiguration?.BodySection?.map((y, index) => {
                    if (['IsBarCodeShow', 'StudentProfilePic', 'AcademicYear', 'Class&Section', 'StudentName'].includes(y?.key)) return null;
                    const value = y?.key === 'DOB' ? (x?.[y?.key] ? moment(x?.[y?.key]).format("DD-MM-YYYY") : '') : x?.[y?.key];
                    if (!value) return null;
                    return (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#09419E', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <i className={getIconForKey(y?.key)} style={{ color: '#FFF', fontSize: '7px' }}></i>
                            </div>
                            <p style={{ margin: 0, fontSize: '6.5px', color: '#09419E', fontWeight: '500', fontFamily: fontStyle }}>
                                {y?.key === 'DOB' ? (x?.[y?.key] ? moment(x?.[y?.key]).format("DD-MM-YYYY") : '') : x?.[y?.key]}
                            </p>
                        </div>
                    )
                })}
            </div>

            {/* Bottom Signature */}
            <div style={{ position: 'absolute', bottom: '32px', right: '15px', zIndex: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {templateConfiguration?.SignImage ? <img src={`${apiBase}/TemplateSign/${templateConfiguration?.SignImage}`} style={{ width: '30px', height: '15px', objectFit: 'contain' }} onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                }} /> : null}
                <p style={{ margin: 0, fontSize: '6px', color: '#09419E', fontWeight: 'bold', fontFamily: fontStyle }}>{templateConfiguration?.AuthorityTitle}</p>
            </div>

            {/* Footer Wave Background */}
            <svg viewBox="0 0 207 60" style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '40px', zIndex: 2 }} preserveAspectRatio="none">
                <path d="M 0,60 L 207,60 L 207,23.5 C 195,34 175,37.1 147,37.1 C 100,37 55,7.7 0,7.7 Z" fill="#09419E" />
                <path d="M 74,8.5 C 105,13 130,18 147,18 C 170,18 195,9 207,2.5 L 207,13 C 195,20 170,25 147,25 C 125,25 95,16 74,8.5 Z" fill="#09419E" />
            </svg>

            {/* Footer Address */}
            <div style={{ position: 'absolute', bottom: '6px', left: '10px', zIndex: 3, maxWidth: '115px' }}>
                <p style={{ margin: 0, fontSize: '5px', color: '#FFF', fontFamily: fontStyle, lineHeight: 1.25, whiteSpace: 'pre-line' }}>
                    {templateConfiguration?.EmailPhoneTextData ? templateConfiguration?.EmailPhoneTextData : (x?.SchoolAddress || '')}
                </p>
            </div>

        </div>
    )
});

export default PreviewIDCardNew;
